var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeployment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.333 2.625H23.833V0H4.333C3.70077 0.0682681 3.12031 0.38105 2.71559 0.871533C2.31087 1.36202 2.11399 1.99131 2.167 2.625V17.063H0V21H15.167V17.063H4.333V2.625ZM24.917 5.25H18.417C18.1008 5.28413 17.8105 5.4406 17.6081 5.68595C17.4057 5.9313 17.3074 6.24607 17.334 6.563V19.688C17.3076 20.0048 17.4061 20.3193 17.6085 20.5644C17.8108 20.8095 18.101 20.9659 18.417 21H24.917C25.233 20.9659 25.5232 20.8095 25.7255 20.5644C25.9279 20.3193 26.0264 20.0048 26 19.688V6.563C26.0266 6.24607 25.9283 5.9313 25.7259 5.68595C25.5235 5.4406 25.2332 5.28413 24.917 5.25ZM23.833 17.063H19.5V7.875H23.833V17.063Z",
    fill: "#283654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployment);
export default __webpack_public_path__ + "static/media/deployment.56b37b7f51a292d1087808bb7b588ca4.svg";
export { ForwardRef as ReactComponent };